/*
 *  ShareBar - Creates a dynamic, vertical sharing bar to the left of a WordPress post and hides it if browser window is too small
 *  Copyright 2010 Monjurul Dolon, http://mdolon.com/
 *  Released under the MIT, BSD, and GPL Licenses.
 *  More information: http://devgrow.com/sharebar
 */
jQuery.fn.sharebar = function(options) {
	var defaults = {horizontal: true, swidth: 72, minwidth: 1000, position: 'left', leftOffset: 20, rightOffset: 10};
	var opts = jQuery.extend(defaults, options); var o = jQuery.meta ? jQuery.extend({}, opts, jQueryjQuery.data()) : opts;

	var w = jQuery(window).width();
	var sharebar = jQuery('#sharebar');
	var sharebarx = jQuery('#sharebarx');
	var parent = jQuery(sharebar).parent().width();
	var start = sharebar_init();

	function sharebar_init(){
		jQuery(sharebar).css('width',o.swidth+'px');
		if (o.position == 'left') jQuery(sharebar).css('marginLeft',(0-o.swidth-o.leftOffset));
		else {
			jQuery(sharebar).css('marginLeft',(parent+o.rightOffset));
		}
		if(w < (o.minwidth+40) && o.horizontal) jQuery(sharebarx).slideDown();
		else jQuery(sharebar).fadeIn();
		jQuery.event.add(window, "scroll", sharebar_scroll);
		jQuery.event.add(window, "resize", sharebar_resize);
		return jQuery(sharebar).offset().top;
	}
	function sharebar_resize() {
		var w = jQuery(window).width();
		if(w<(o.minwidth+40)){
			jQuery(sharebar).fadeOut();
			if(o.horizontal) jQuery(sharebarx).slideDown();
		}else{
			jQuery(sharebar).fadeIn();
			if(o.horizontal) jQuery(sharebarx).slideUp();
		}
	}
	function sharebar_scroll() {
		var p = jQuery(window).scrollTop();
		var w = jQuery(window).width();
		jQuery(sharebar).css('position',((p+10)>start) ? 'fixed' : 'absolute');
		jQuery(sharebar).css('top',((p+10)>start) ? '10px' : '');
	}

};
/**
 * Handles form submissions for Google recaptcha v3.
 * Allows for HTML5 form validation to complete before processing.
 */
function formSubmitBtn($event) {
	if (!$event.target.form.checkValidity()) {
		return;
	}
	$event.preventDefault();
	if (!grecaptcha) {
		throw new Error('grecaptcha does not exist in the global scope.  Was the script included?');
	}
	if (!window.bctTheme || !window.bctTheme.grecaptchaSiteKey) {
		throw new Error('grecaptcha site keys is missing/invalid from the bctTheme object.  Does the theme object exist and was the property added to the object?');
	}
	grecaptcha.ready(function() {
		grecaptcha.execute(window.bctTheme.grecaptchaSiteKey, { action: 'submit' }).then(function(token) {
			$event.target.form.elements['g-recaptcha-response'].value = token;
			$event.target.form.submit();
		});
	});
}

jQuery(document).ready(function($) {
	// Sharebar
	$('.sharebar').sharebar({horizontal:'false',swidth:'72',minwidth:1000,position:'left',leftOffset:15,rightOffset:10});
	// Twitter Share for sharebar
	(function(d, s, id) { var js, fjs = d.getElementsByTagName(s)[0]; if (!d.getElementById(id)) { js = d.createElement(s); js.id = id; js.src = "//platform.twitter.com/widgets.js"; fjs.parentNode.insertBefore(js, fjs); } }(document, "script", "twitter-wjs"));
	// Facebook like Icon for sharebar
	(function(d, s, id) { var js, fjs = d.getElementsByTagName(s)[0]; if (d.getElementById(id)) return; js = d.createElement(s); js.id = id; js.src = "//connect.facebook.net/en_US/all.js#xfbml=1"; fjs.parentNode.insertBefore(js, fjs);}(document, 'script', 'facebook-jssdk'));
	// Caption Tags
	(function() {
		var setNumber = 0;
		var tagsInitiated = false;
		var tagsCount = 4;
		var processTags = setInterval(displayTags, 4250);
		function displayTags() {
			setNumber++;
			$(".set" + setNumber).fadeIn(800);
			if ((setNumber == 1) && (tagsInitiated == true)) {
				$(".set" + tagsCount).fadeOut(800);
			} else if (setNumber >= 2) {
				$(".set" + (setNumber - 1)).fadeOut(800);
			};
			if (setNumber >= tagsCount) {
				clearInterval(processTags);
			};
			tagsInitiated = true;
		};
		displayTags();
	})();
});
